import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const FACES = [["/photos/fondatrice-nolwenn.jpg?v=4", "Nolwenn, co-fondatrice"], ["/photos/fondateur-malo.jpg?v=4", "Malo, co-fondateur"]];

export function FoundersBand() {
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20" data-testid="home-founders">
      <Reveal>
        <div className="rounded-[32px] bg-[#f3ede1] ring-1 ring-[#e6dcc8] p-7 sm:p-10 lg:p-12 flex flex-col md:flex-row md:items-center gap-8 lg:gap-12">
          <div className="flex shrink-0">
            {FACES.map(([src, alt], i) => (
              <img key={src} loading="lazy" decoding="async" src={src} alt={alt} data-testid={`home-founder-photo-${i}`}
                className={`w-24 h-24 lg:w-32 lg:h-32 rounded-full object-cover object-top ring-4 ring-[#faf7f0] shadow-[0_20px_40px_-20px_rgba(19,38,28,0.5)] transition-transform duration-300 hover:-translate-y-1 ${i ? "-ml-6 lg:-ml-8" : "relative z-10"}`} />
            ))}
          </div>
          <div className="flex-1">
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#c4703f]">Les fondateurs</span>
            <p className="mt-3 font-logo font-black text-2xl lg:text-3xl text-[#13261c] leading-tight">Une équipe d'ici, fondée par Nolwenn et Malo<span className="text-[#d9895a]">.</span></p>
            <p className="mt-3 text-[#5a6158] leading-relaxed max-w-2xl">Originaires de la Côte d'Émeraude, ils ont créé une conciergerie à taille humaine, qui prend soin de chaque logement comme du sien.</p>
          </div>
          <Link to="/qui-sommes-nous" data-testid="home-founders-link"
            className="group inline-flex items-center gap-2 self-start md:self-center rounded-full px-6 py-3.5 font-bold bg-[#13261c] hover:bg-[#2a4636] text-white transition-colors shrink-0">
            Découvrir notre histoire <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
